import script from "./GoalItem.vue?vue&type=script&setup=true&lang=js"
export * from "./GoalItem.vue?vue&type=script&setup=true&lang=js"

import "./GoalItem.vue?vue&type=style&index=0&id=88c059f4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88c059f4"]])

export default __exports__